export default "__VITE_ASSET__D7ODoZ17__"